export enum WebsiteBackground {
    NONE = 'none',
    CARBON = 'carbon',
    STARS_1 = 'stars_1',
    STARS_2 = 'stars_2',
    LEAVES = 'leaves',
    CUSTOM = 'custom'
}
